<template>
  <ModalsContainer></ModalsContainer>
</template>

<script setup lang="js">
  import { subscribe } from '@services/GlobalEventBus'
  import { ModalsContainer, useModal } from 'vue-final-modal'

  // Store modal instances so we can close them
  // lets use Map so we can use .set and .delete to make our lives easier
  const modalInstances = new Map()

  subscribe('modal:spawn', (data) => {
    console.log("CAUGHT IT IN: ModalsApp.vue", data)

    const { open, close, destroy } = useModal({
      component: data.modal,
      attrs: {
        onClose() {
          close()
          destroy()
          modalInstances.delete(data.modal)
        },
        params: data.bind.data,
      },
    })

    // Store the close function for this modal
    modalInstances.set(data.modal, close)

    open().then(() => {
      console.log("opening modal!")
    })
  })

  subscribe('modal:close', (data) => {
    console.log("wooohooo closing", data)
    const closeFn = modalInstances.get(data.modal)
    if (closeFn) {
      closeFn()
      modalInstances.delete(data.modal)
    }
  })
</script>
